jQuery( document ).ready(function($) {

  const selectors = Object.freeze({
    addToCartBtn: '.add-to-cart-order-form'
  });

  // PROCESS VARIANTS TO CHECKOUT
  
  Shopify.queue = [];
  variant = variant_id;
  //console.log( variant );
  
  $('#addToCartBtn').click(function() {
    //console.log('Button Click');
    $(this).text('Adding');
    $(this).val('Adding');
    $(this).addClass('disabled');
    push_to_queue(variant, 1, { 'Sphere': '+2.00', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '+1.75', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '+1.50', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '+1.25', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '+1.25', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 1, { 'Sphere': '+1.25', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '+1.00', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '+1.00', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 1, { 'Sphere': '+1.00', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.75', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.75', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.75', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.75', 'Cylinder': '-0.75' } );   
    push_to_queue(variant, 1, { 'Sphere': '+0.50', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.50', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.50', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.50', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.50', 'Cylinder': '-1.00' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.25', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.25', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.25', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.25', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 1, { 'Sphere': '+0.25', 'Cylinder': '-1.00' } );    
    push_to_queue(variant, 1, { 'Sphere': '0.00', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '0.00', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 3, { 'Sphere': '0.00', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 2, { 'Sphere': '0.00', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 1, { 'Sphere': '0.00', 'Cylinder': '-1.00' } );
    push_to_queue(variant, 1, { 'Sphere': '0.00', 'Cylinder': '-1.25' } );
    push_to_queue(variant, 1, { 'Sphere': '0.00', 'Cylinder': '-1.50' } );
    push_to_queue(variant, 1, { 'Sphere': '-0.25', 'Cylinder': '0.00' } );   
    push_to_queue(variant, 2, { 'Sphere': '-0.25', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 2, { 'Sphere': '-0.25', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 2, { 'Sphere': '-0.25', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 1, { 'Sphere': '-0.25', 'Cylinder': '-1.00' } );
    push_to_queue(variant, 1, { 'Sphere': '-0.25', 'Cylinder': '-1.25' } );
    push_to_queue(variant, 3, { 'Sphere': '-0.50', 'Cylinder': '0.00' } );
    push_to_queue(variant, 2, { 'Sphere': '-0.50', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 3, { 'Sphere': '-0.50', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 2, { 'Sphere': '-0.50', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 1, { 'Sphere': '-0.50', 'Cylinder': '-1.00' } );
    push_to_queue(variant, 1, { 'Sphere': '-0.50', 'Cylinder': '-1.25' } );
    push_to_queue(variant, 3, { 'Sphere': '-0.75', 'Cylinder': '0.00' } );
    push_to_queue(variant, 2, { 'Sphere': '-0.75', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 2, { 'Sphere': '-0.75', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '-0.75', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 1, { 'Sphere': '-0.75', 'Cylinder': '-1.00' } );
    push_to_queue(variant, 3, { 'Sphere': '-1.00', 'Cylinder': '0.00' } );
    push_to_queue(variant, 2, { 'Sphere': '-1.00', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 2, { 'Sphere': '-1.00', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.00', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.00', 'Cylinder': '-1.00' } );
    push_to_queue(variant, 3, { 'Sphere': '-1.25', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.25', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 2, { 'Sphere': '-1.25', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.25', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.25', 'Cylinder': '-1.00' } );
    push_to_queue(variant, 2, { 'Sphere': '-1.50', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.50', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.50', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.50', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 2, { 'Sphere': '-1.75', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.75', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.75', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '-1.75', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 1, { 'Sphere': '-2.00', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '-2.00', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 1, { 'Sphere': '-2.00', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '-2.00', 'Cylinder': '-0.75' } );
    push_to_queue(variant, 1, { 'Sphere': '-2.25', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '-2.25', 'Cylinder': '-0.25' } );
    push_to_queue(variant, 1, { 'Sphere': '-2.25', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '-2.50', 'Cylinder': '0.00' } );
    push_to_queue(variant, 1, { 'Sphere': '-2.50', 'Cylinder': '-0.50' } );
    push_to_queue(variant, 1, { 'Sphere': '-2.75', 'Cylinder': '0.00' } );    

    Shopify.moveAlong();
    
  });

  Shopify.moveAlong = function() {
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
    }
    else {
      document.location.href = '/cart';
      //console.log('Done!');
    }
  };

  Shopify.addItem = function(id, qty, properties, callback) {
    
    var params = {
      quantity: qty,
      id: id, 
      properties: properties
    };
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: params,
      success: function(){
        if(typeof callback === 'function'){
          callback();
        }
      },
      error: function(){
      }
    });
  }
  
  function push_to_queue(variantID, quantity, properties) {
    // console.log('Shopify Queue Push');
    // Show Animating icon
    $(selectors.addToCartBtn).parent().find('.wait-message').css({'opacity': '1'});
    Shopify.queue.push({
      variantId: variantID,
      quantity: quantity,
      properties: properties
    });

  }
});
